import * as React from 'react';
import * as author from './style.module.scss';
export const Author = () => {
  return (
    <section className={`${author.author} container`}>
      <h2 className={author.author__title}>Автор и преподаватель курса</h2>
      <div className={author.author__container}>
        <div className={author.author__el}>
          <img
            src="https://fs.advance.ru/landing-pages/course/kurs-razvitiya-pamyaty/photo-NJ.png"
            alt=""
            className={author.author__photo}
          />
          <p className={author.author__name}>
            Николай Ягодкин
          </p>
          <div className={author.author__description}>
            <p>Основатель образовательного центра Advance</p>
            <p>Автор курса и эксперт с 11-летним опытом преподавания </p>
          </div>
        </div>
      </div>
    </section>
  );
};
